import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86f668ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "info_box_title" }, " HELLO THERE ", -1))
const _hoisted_2 = { class: "satellite_info_box" }
const _hoisted_3 = { class: "satellite_info_box" }
const _hoisted_4 = { class: "info_box_title" }
const _hoisted_5 = { class: "area_info_list" }
const _hoisted_6 = { class: "lat" }
const _hoisted_7 = { class: "lon" }
const _hoisted_8 = { class: "country" }
const _hoisted_9 = ["src", "alt"]

import { computed, onMounted, watch } from 'vue';
import { storeToRefs } from 'pinia';

import useCommonStore from '@/store/storeCommon';
import useMapStore from '@/store/storeMap';
import useMemberStore from '@/store/storeMember';



export default /*#__PURE__*/_defineComponent({
  __name: 'SatelliteInfo',
  setup(__props) {

const { isSatelliteInfo } = storeToRefs(useCommonStore());
const {
  satelliteTleData,
  getCountry,
  executeApiOnSchedule,
  getSatelliteName,
  getCoordinate,
  satelliteInfo,
  getSatelliteDataApi,
} = useMapStore();
const { accessedMemberInfo, getLevelImageSrc, getLevelName } = useMemberStore();

/**
 * 현재 위치를 확인하는 초기 동작입니다.
 */
watch(satelliteTleData, () => {
  getCountry();
});

/**
 * 5초마다 한번씩 현재 위치를 확인합니다.
 */
onMounted(async () => {
  await getSatelliteDataApi();

  const intervalId = setInterval(() => {
    getCountry();
    executeApiOnSchedule();
  }, 5000);

  if (satelliteTleData.trackingTables.length === 0) {
    clearInterval(intervalId);
  }
});

/**
 * 실시간 지역 이름을 가져옵니다.
 */
const getCountryName = computed((): string => {
  return satelliteInfo.locationName === ''
    ? '찾는중'
    : `In ${satelliteInfo.locationName}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_unref(isSatelliteInfo))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["info_box", {'user' : _unref(accessedMemberInfo).name, 'tracking_mode' : _unref(satelliteInfo).isCurrentTrackingSat}])
          }, [
            (!_unref(accessedMemberInfo).name)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_1,
                  _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(getSatelliteName)()), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getSatelliteName)()) + "'s OREUM SAT ", 1),
                  _createElementVNode("h2", _hoisted_4, " HELLO " + _toDisplayString(_unref(getLevelName)()), 1)
                ], 64)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(getCoordinate)("Lat")) + "N ", 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(getCoordinate)("Lon")) + "E ", 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(getCountryName.value), 1)
              ])
            ]),
            (_unref(accessedMemberInfo).name)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 2,
                  class: "character",
                  src: _unref(getLevelImageSrc)(_unref(accessedMemberInfo).level,''),
                  alt: `${_unref(accessedMemberInfo).level}`
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})